import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prose } from '@/components/layout/Prose';

interface MarkdownNotesProps {
  source: string;
}

const EXTRA_STYLES = [
  '[&_pre]:my-4 [&_pre]:overflow-x-auto [&_pre]:rounded-lg [&_pre]:border [&_pre]:border-border',
  '[&_pre]:bg-muted/40 [&_pre]:p-4 [&_pre>code]:bg-transparent [&_pre>code]:p-0',
  '[&_table]:my-4 [&_table]:w-full [&_table]:border-collapse [&_th]:border [&_th]:border-border [&_th]:bg-muted/40 [&_th]:px-3 [&_th]:py-2 [&_th]:text-start',
  '[&_td]:border [&_td]:border-border [&_td]:px-3 [&_td]:py-2',
  '[&_blockquote]:my-4 [&_blockquote]:border-s-4 [&_blockquote]:border-brand/40 [&_blockquote]:bg-muted/20 [&_blockquote]:ps-4 [&_blockquote]:py-2',
  '[&_a]:break-words',
].join(' ');

export function MarkdownNotes({ source }: MarkdownNotesProps) {
  return (
    <Prose className={EXTRA_STYLES}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children, ...props }) => (
            <a
              href={href}
              target={href?.startsWith('http') ? '_blank' : undefined}
              rel={href?.startsWith('http') ? 'noopener noreferrer' : undefined}
              {...props}
            >
              {children}
            </a>
          ),
        }}
      >
        {source}
      </ReactMarkdown>
    </Prose>
  );
}
